import { useEffect } from 'react'
import { useSignal, batch } from '@preact/signals-react'
import { postSubmit } from '@ui-seeker/utils'

import { isLoadingCommonFilters, commonFiltersValue, isSystemBusy } from '@signals'
import { WEBBACK_V2_API } from '@constants'
import { sideComparisonIsEmpty } from "../@signals";


export default function usePricingSideComparisonFilters() {

    const data = useSignal([])
    const firstRetailer = useSignal(null)
    const secondRetailer = useSignal(null)

    useEffect(() => {
        if (isLoadingCommonFilters.value) batch(() => {
            postSubmit(`${WEBBACK_V2_API}/pricing/side-comparison/context`, commonFiltersValue.value)
                .then(res => {
                    if (!res.data?.length)
                        sideComparisonIsEmpty.value = true
                    data.value = res.data
                    firstRetailer.value = res.firstRetailerTitle
                    secondRetailer.value = res.secondRetailerTitle
                    isLoadingCommonFilters.value = false
                })
                .catch(() => {
                    isSystemBusy.value = true
                    isLoadingCommonFilters.value = false
                })
        })
    }, [isLoadingCommonFilters.value])

    return {
        data: data.value,
        firstRetailer: firstRetailer.value,
        secondRetailer: secondRetailer.value
    }
}